import React, { useEffect, useState } from 'react';
import { Form, FormItem, StyledButton } from './styles';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/material.css'
import Swal from "sweetalert2";
import { Title } from '../../Pages/Home/styles';
import { addDays,  getDay, parse, setHours} from "date-fns";
import IAgendamento, { Status } from '../../Interfaces/agendamento/agendamento.interface';
import api from '../../Services/ApiService';
import { useHistory } from 'react-router';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ptBR from 'date-fns/locale/pt-BR';
import './styles.css'
import { format } from 'date-fns/esm';
import { SyntheticEvent } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, CircularProgress, Container, FormControl, InputLabel, MenuItem, Radio, Select, TextField  } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ISessao from '../../Interfaces/sessao/sessao.interface';
import IVL_HorarioDisponivel from '../../Interfaces/horarioDisponivel/VL_horarioDisponivel.interface';
import { DateTimePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ptbrLocal from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR)


const filterDate = (date: Date) => {
  const day = getDay(date);
  return day !== 0 && day !== 6 && date > addDays(new Date(),2);
}

const validateDataHoraSessao = (dataHoraSessao: Date | null | undefined) => {
  return (dataHoraSessao !== (null||undefined)) && dataHoraSessao?.getHours() !== 0;
}


const FormAgendamentoPresencial: React.FC = () => {

  const [futurosAgendamentos,setFuturosAgendamentos] = useState<Date[]>([]);
  const [horariosIndisponiveis,setHorariosIndisponiveis] = useState<Date[]>([]);
  const [diasSemAgendamentoDisponivel,setDiasSemAgendamentoDisponivel] = useState<Date[]>([]);
  const [sessoes,setSessoes] = useState<ISessao[]>([])
  const [horariosDisponiveis,setHorariosDisponiveis] = useState<Date[]>([]);
  const [horarioDiferente,setHorarioDiferente] = useState<boolean>(false);

  const [nome,setNome] = useState<string>('');
  const [email,setEmail] = useState<string>('');
  const [telefone,setTelefone] = useState<string>('');
  const [sessaoEscolhidaId, setSessaoEscolhidaId] = useState<number>(0);
  const [dataHoraSessao,setDataHoraSessao] = useState<Date|null>();
  const [instituicao, setInstituicao] = useState<string>('');
  const [municipio, setMunicipio] = useState<string>('');
  const [serie,setSerie] = useState<string>('');
  const [alunos,setAlunos] = useState<number>(0);
  const [professor,setProfessor] = useState<string>('');
  const [emailProfessor,setEmailProfessor] = useState<string>('');
  const [tipoEscola,setTipoEscola] = useState<string>('');
  const [telefoneEscola,setTelefoneEscola] = useState<string>('');
  const [telefoneProfessor,setTelefoneProfessor] = useState<string>('');
  const [alunoDeficiente,setAlunoDeficiente] = useState<string>('');
  const [loaded,setLoaded] = useState<boolean>(false);
  const [loading,setLoading] = useState<boolean>(false);
  const [accordionExpanded,setAccordionExpanded] = useState<string>('');
  const history = useHistory();

  const filterTime = (time: Date): boolean => {
    const sameHorario = horariosDisponiveis.find(horario=>horario.toLocaleTimeString()===time.toLocaleTimeString());
    return dataHoraSessao !== null && dataHoraSessao !== undefined && sameHorario !== undefined;
  };

  const onSelectDate = (date:Date,event:SyntheticEvent) => {
    setDataHoraSessao(setHours(date,0));
    setHorariosIndisponiveis(futurosAgendamentos.filter(fa=>format(fa,"dd/MM/yyyy") === format(date,"dd/MM/yyyy")));
  };

  const getUnavailableAgendamentosDates = async () => {
    try {
      const { data } = await api.get<string[]>(`/agendamentos/GetUnavailableHorariosPresenciais`);
      const futureAgendamentos : Date[] = data.map((d: string)=> new Date(d));
      setFuturosAgendamentos(futureAgendamentos);
      const diasSemAgendamentoComMaisDeUmHorarioString = futureAgendamentos
        .map(function (date) { return format(date,"dd/MM/yyyy") })
        .filter(function (date, i, array) {
            return array.indexOf(date) !== i;
        });
      const diasSemAgendamentoComMaisDeUmHorarioDate = diasSemAgendamentoComMaisDeUmHorarioString.map(dia=> parse(dia, 'dd/MM/yyyy', new Date()));
      setDiasSemAgendamentoDisponivel(diasSemAgendamentoComMaisDeUmHorarioDate);
      setLoaded(true);
    } catch (error:any) {
      console.error(error);
      return Swal.fire({
        title:'Erro!',
        text:`${error}`,
        icon: 'error'
      })
    }
  }
  
  const getSessoes = async () => {
    const { data } = await api.get<ISessao[]>(`/sessoes/presenciais`);
    setSessoes(data);
  }

  const getHorariosDisponiveis = async () => {
    const { data } = await api.get<IVL_HorarioDisponivel[]>(`/vl_horariosdisponiveis/presenciais`);
    const horariosDisponiveisDateFormat = data.map((horario,index)=>{
      return new Date(horario.horario);
    })
    console.log(horariosDisponiveisDateFormat);
    setHorariosDisponiveis(horariosDisponiveisDateFormat);
  }
  
  useEffect(() => {
    getUnavailableAgendamentosDates();
    getSessoes();
    getHorariosDisponiveis();
  },[]);

  const handleSubmit = async (event:React.FormEvent) => {
    event.preventDefault();
    if(sessaoEscolhidaId === 0) 
      return Swal.fire({
        title:'Erro!',
        text:'Escolha uma sessão',
        icon: 'error'
      })
    if(validateDataHoraSessao(dataHoraSessao)){
      const dataHoraSessaoString = dataHoraSessao!==null&&dataHoraSessao!==undefined? format(dataHoraSessao, "yyyy-MM-dd'T'HH:mm:ss"):"";
      const agendamento: IAgendamento = {
        id:0,
        status: horarioDiferente ? Status.Pendente : Status.Aprovado,
        nome,
        email,
        telefone,
        sessaoEscolhidaId,
        sessaoEscolhida:undefined,
        dataHoraSessao: dataHoraSessaoString,
        instituicao,
        municipio,
        serie,
        alunos,
        professor,
        emailProfessor,
        tipoEscola,
        telefoneEscola,
        telefoneProfessor,
        alunoDeficiente,
        excluido:false,
        virtual:false
      }
      try {
        setLoading(true);
        await api.post('/agendamentos',agendamento);
        Swal.fire({
          title:'Sucesso!',
          text:'Seu agendamento foi efetuado com sucesso. Confira seu e-mail para mais informações! Obrigado!',
          icon: 'success'
        }).then((result)=>{
          if(result.isConfirmed)
            history.push('/')
        })
      } catch (error:any) {
        console.log(error);
        setLoading(false);
        return Swal.fire({
          title:'Erro!',
          text:`${error.response.data}`,
          icon: 'error'
        })
      }
    }
    else{
      return Swal.fire({
        title:'Erro!',
        text:'A data selecionada não é válida',
        icon: 'error'
      })
    }
  }
  
  return (
    <Container style={{backgroundColor:'rgba(255,255,255,0.8)',minHeight:600}} maxWidth="sm">
      {horariosDisponiveis.length > 0 && sessoes.length > 0? 
      (
      <Form onSubmit={handleSubmit}>
        <Title>Agendar Sessão Presencial</Title>
        {loaded ? (
          <>
            <FormItem>
              <TextField 
                type="text" 
                required 
                label="Seu nome" 
                value={nome || ''}
                onChange={(event)=>setNome(event.target.value)}
                placeholder="Insira seu nome"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <TextField 
                type="email" 
                required 
                label="Seu e-mail"
                value={email || ''} 
                onChange={(event)=>setEmail(event.target.value)}
                placeholder="Insira seu melhor e-mail"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <PhoneInput
                specialLabel="Seu telefone"
                inputStyle={{width:'100%',backgroundColor:'rgba(255,255,255,0.3)'}}
                country={"br"} 
                value={telefone || ''} 
                onChange={(number)=>{setTelefone(number)}}
                regions={[ 'south-america']}
                placeholder="Insira seu telefone"
              />
            </FormItem>
            <FormItem>
              <FormControl style={{width:'100%'}}>
                <h3 style={{textAlign:'left'}}>Escolha a sessão</h3>
                {sessoes.map((sessao,index)=> { return (
                  <Accordion key={index} expanded={accordionExpanded===`accordion${index}`} onChange={()=>{setAccordionExpanded(`accordion${index}`)}} >
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                      <div style={{alignItems:'center'}} > 
                        <Radio
                          checked={sessaoEscolhidaId === sessao.id}
                          onChange={(event)=> {setSessaoEscolhidaId(parseInt(event.target.value))}}
                          value={sessao.id}
                          name="radio-buttons"
                          inputProps={{ 'aria-label': sessao.titulo }}
                        />
                        {sessao.titulo}
                      </div>
                      </AccordionSummary>
                    <AccordionDetails style={{fontSize:16,textAlign: 'justify', textJustify:'inter-word'}}>
                      <b>Tópicos abordados:</b> {sessao.tópicos}
                      <br/>
                      <br/>
                      <b>Sinopse:</b> {sessao.sinopse}
                      <br/>
                      <br/>
                      <b>Recomendação:</b> {sessao.recomendação}
                    </AccordionDetails>
                  </Accordion>
                )})}
              </FormControl>
            </FormItem>
            <FormItem className="customDatePickerWidth" style={{textAlign: 'left'}}>
              <h3>Escolha o dia e horário da sessão</h3>
              <small>Dia e horário selecionado: {dataHoraSessao !== null && dataHoraSessao !== undefined && format(dataHoraSessao, "dd/MM/yyyy HH:mm")}</small>
              {horarioDiferente?(
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptbrLocal}>
                  <DateTimePicker
                    renderInput={(props) => 
                      <TextField 
                        {...props}
                        style={{width:'100%'}} />
                    }
                    value={dataHoraSessao}
                    onChange={(dataSessao) => setDataHoraSessao(dataSessao)}
                  />
                </LocalizationProvider>
              ):(
                <ReactDatePicker
                  inline
                  selected={dataHoraSessao}
                  onChange={(dataSessao : Date) => setDataHoraSessao(dataSessao)}
                  onSelect={onSelectDate}
                  locale="pt-BR"
                  showTimeSelect
                  timeCaption="Horário"
                  filterDate={filterDate}
                  filterTime={filterTime}
                  excludeDates={diasSemAgendamentoDisponivel}
                  dayClassName={(dia)=> 
                    dia.getTime()=== dataHoraSessao?.getTime() ? 
                      "react-datepicker__day--selected" :  
                      (diasSemAgendamentoDisponivel.find(diaindisponivel => diaindisponivel.getTime() ===  dia.getTime()) 
                      || (dia.getDate() < 20 && dia.getMonth() === 11 && dia.getFullYear() === 2021 && dia.getDay() !== 0 && dia.getDay()!==6) ?
                        "unavailableDay" : 
                        (filterDate(dia) ? "availableDay": null)
                      )
                  }
                  excludeTimes={horariosIndisponiveis}
                  dateFormat="dd/MM/yyyy HH:mm"
                  required
                />
              )}
              <Checkbox checked={horarioDiferente} onChange={(event)=>setHorarioDiferente(event.target.checked)}/>
              <small>
                Solicitar um agendamento em um horário diferente <b> (Mediante aprovação do Planetário da UFSM.)</b>
              </small>
            </FormItem>
            <FormItem>
              <FormControl style={{width:'100%'}}>
                <InputLabel id="demo-simple-select-helper-label">Ano</InputLabel> 
                <Select
                  value={serie || ''}
                  onChange={(event)=>setSerie(event.target.value as string)}
                  required
                  label="Ano"
                >
                  <MenuItem value="Educação Infantil">
                    Educação Infantil
                  </MenuItem>
                  <MenuItem value="1º Ano do Ensino Fundamental">
                    1º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="2º Ano do Ensino Fundamental">
                    2º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="3º Ano do Ensino Fundamental">
                    3º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="4º Ano do Ensino Fundamental">
                    4º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="5º Ano do Ensino Fundamental">
                    5º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="6º Ano do Ensino Fundamental">
                    6º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="7º Ano do Ensino Fundamental">
                    7º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="8º Ano do Ensino Fundamental">
                    8º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="9º Ano do Ensino Fundamental">
                    9º Ano do Ensino Fundamental
                  </MenuItem>
                  <MenuItem value="1º Ano do Ensino Médio">
                    1º Ano do Ensino Médio
                  </MenuItem>
                  <MenuItem value="2º Ano do Ensino Médio">
                    2º Ano do Ensino Médio
                  </MenuItem>
                  <MenuItem value="3º Ano do Ensino Médio">
                    3º Ano do Ensino Médio
                  </MenuItem>
                  <MenuItem value="Ensino Superior">
                    Ensino Superior
                  </MenuItem>
                  <MenuItem value="Outro">
                    Outro
                  </MenuItem>
                </Select>
              </FormControl>
            </FormItem>
            <FormItem>
              <TextField 
                type="number" 
                InputProps={{inputProps:{min:10}}}
                required 
                label="Número de alunos" 
                value={alunos > 0 ? alunos : ''}
                onChange={(event)=>setAlunos(parseInt(event.target.value))}
                placeholder="Insira o número de alunos"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <TextField 
                type="text" 
                required 
                label="Professor responsável" 
                value={professor || ''}
                onChange={(event)=>setProfessor(event.target.value)}
                placeholder="Insira o nome do professor responsável"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <TextField 
                type="text" 
                required 
                label="E-mail do professor" 
                value={emailProfessor || ''}
                onChange={(event)=>setEmailProfessor(event.target.value)}
                placeholder="Insita o e-mail do professor responsável"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <PhoneInput
                specialLabel="Telefone do professor reponsável"
                inputStyle={{width:'100%',backgroundColor:'rgba(255,255,255,0.3)'}}
                country={"br"} 
                value={telefoneProfessor || ''} 
                onChange={(number)=>{setTelefoneProfessor(number)}}
                regions={['south-america']}
                placeholder="Insira o telefone do professor responsável"
              />
            </FormItem>
            <FormItem>
            <FormControl style={{width:'100%'}}>
                <InputLabel id="demo-simple-select-helper-label">Tipo de escola</InputLabel> 
                <Select
                  value={tipoEscola || ''}
                  onChange={(event)=>setTipoEscola(event.target.value as string)}
                  required
                  label="Tipo de escola"
                >
                  <MenuItem value="Municipal">
                    Municipal
                  </MenuItem>
                  <MenuItem value="Estadual">
                    Estadual
                  </MenuItem>
                  <MenuItem value="Federal">
                    Federal
                  </MenuItem>
                  <MenuItem value="Particular">
                    Particular
                  </MenuItem>
                  <MenuItem value="Outro">
                    Outro
                  </MenuItem>
                </Select>
              </FormControl>
            </FormItem>
            <FormItem>
              <PhoneInput
                specialLabel="Telefone da escola"
                inputStyle={{width:'100%',backgroundColor:'rgba(255,255,255,0.3)'}}
                country={"br"} 
                value={telefoneEscola || ''} 
                onChange={(number)=>{setTelefoneEscola(number)}}
                regions={['south-america']}
                placeholder="Insira o telefone da escola"
              />
            </FormItem>
            <FormItem>
              <TextField 
                type="text" 
                required 
                label="Nome da instituição" 
                value={instituicao || ''}
                onChange={(event)=>setInstituicao(event.target.value)}
                placeholder="Insira o nome da instituição"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <TextField 
                type="text" 
                required 
                label="Município" 
                value={municipio || ''}
                onChange={(event)=>setMunicipio(event.target.value)}
                placeholder="Insira o nome do município"
                style={{width:'100%'}}
              />
            </FormItem>
            <FormItem>
              <TextField 
                type="text"
                required 
                label="A turma possui algum aluno com deficiência? Se sim, qual(is)?" 
                value={alunoDeficiente || ''}
                onChange={(event)=>setAlunoDeficiente(event.target.value)}
                placeholder="Insira se sim ou não, se sim informe a deficiência."
                style={{width:'100%'}}
              />
            </FormItem>
            <StyledButton 
              variant="contained"
              type="submit">{loading ? <CircularProgress/> : 'Agendar'}
            </StyledButton>
          </>
        )
        :
        (
          <div style={{display: 'flex', alignItems: 'center',justifyContent: 'center',height: '100vh'}}>
            <CircularProgress size="10rem"/>
          </div>
        )
        }
        
      </Form>
      )
      :
      (
        <>
          <Title>Agendar Sessão Presencial</Title>
          Não estão sendo ofertadas sessões presenciais no momento
        </>
      )}
      
    </Container>
  );
}

export default FormAgendamentoPresencial;